import { render, staticRenderFns } from "./VenExD_Details.vue?vue&type=template&id=95d02f66"
import script from "./VenExD_Details.vue?vue&type=script&lang=js"
export * from "./VenExD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports